(() => {
  const root = document.querySelector("[data-hiq-home]");
  if (!root || root.dataset.hiqReady === "true") return;
  root.dataset.hiqReady = "true";

  const routeRoot = window.Shopify?.routes?.root || "/";
  const drawer = root.querySelector("[data-cart-drawer]");
  const backdrop = root.querySelector("[data-cart-backdrop]");
  const cartItems = root.querySelector("[data-cart-items]");
  const cartEmpty = root.querySelector("[data-cart-empty]");
  const cartSummary = root.querySelector("[data-cart-summary]");
  const cartCountNodes = root.querySelectorAll("[data-cart-count]");
  const cartLabel = root.querySelector("[data-cart-items-label]");
  const cartSubtotal = root.querySelector("[data-cart-subtotal]");
  const cartOpenButtons = root.querySelectorAll("[data-cart-open]");
  const mobileMenu = root.querySelector("[data-mobile-menu]");
  const menuBackdrop = root.querySelector("[data-menu-backdrop]");
  const menuOpenButton = root.querySelector("[data-menu-open]");
  const menuCloseButton = root.querySelector("[data-menu-close]");
  const searchOverlay = root.querySelector("[data-search-overlay]");
  const searchInput = root.querySelector("[data-search-input]");
  const heroStage = root.querySelector(".hero-product");

  const formatMoney = (cents) =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format((Number(cents) || 0) / 100);

  const escapeHtml = (value = "") =>
    String(value)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");

  const openDrawer = () => {
    drawer?.classList.add("is-open");
    backdrop?.classList.add("is-open");
    drawer?.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("hiq-lock");
    drawer?.querySelector("[data-cart-close]")?.focus();
  };

  const closeDrawer = () => {
    drawer?.classList.remove("is-open");
    backdrop?.classList.remove("is-open");
    drawer?.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("hiq-lock");
  };

  const openMenu = () => {
    mobileMenu?.classList.add("is-open");
    menuBackdrop?.classList.add("is-open");
    mobileMenu?.setAttribute("aria-hidden", "false");
    menuBackdrop?.setAttribute("aria-hidden", "false");
    menuOpenButton?.setAttribute("aria-expanded", "true");
    document.documentElement.classList.add("hiq-lock");
    menuCloseButton?.focus();
  };

  const closeMenu = (restoreFocus = true) => {
    mobileMenu?.classList.remove("is-open");
    menuBackdrop?.classList.remove("is-open");
    mobileMenu?.setAttribute("aria-hidden", "true");
    menuBackdrop?.setAttribute("aria-hidden", "true");
    menuOpenButton?.setAttribute("aria-expanded", "false");
    document.documentElement.classList.remove("hiq-lock");
    if (restoreFocus) menuOpenButton?.focus();
  };

  const renderCart = (cart) => {
    const count = Number(cart.item_count) || 0;
    cartCountNodes.forEach((node) => {
      node.textContent = String(count);
    });
    cartOpenButtons.forEach((button) => {
      button.setAttribute(
        "aria-label",
        "Shopping bag with " + count + (count === 1 ? " item" : " items")
      );
    });
    if (cartLabel) {
      cartLabel.textContent = count + (count === 1 ? " item" : " items");
    }
    if (cartSubtotal) {
      cartSubtotal.textContent = formatMoney(cart.total_price);
    }

    const hasItems = count > 0;
    if (cartEmpty) cartEmpty.hidden = hasItems;
    if (cartItems) cartItems.hidden = !hasItems;
    if (cartSummary) cartSummary.hidden = !hasItems;

    if (!cartItems) return;
    cartItems.innerHTML = (cart.items || [])
      .map((item) => {
        const image = item.image
          ? '<img src="' + escapeHtml(item.image) + '" alt="" width="168" height="168">'
          : "";
        return (
          "<article>" +
          image +
          "<div>" +
          "<small>" +
          escapeHtml(item.vendor || "Holistiq IQ") +
          "</small>" +
          "<strong>" +
          escapeHtml(item.product_title) +
          "</strong>" +
          "<span>" +
          formatMoney(item.final_line_price) +
          "</span>" +
          "</div>" +
          '<button type="button" aria-label="Remove ' +
          escapeHtml(item.product_title) +
          '" data-cart-remove="' +
          escapeHtml(item.key) +
          '">×</button>' +
          "</article>"
        );
      })
      .join("");
  };

  const getCart = async () => {
    const response = await fetch(routeRoot + "cart.js", {
      headers: { Accept: "application/json" },
    });
    if (!response.ok) throw new Error("Unable to load cart");
    const cart = await response.json();
    renderCart(cart);
    return cart;
  };

  cartOpenButtons.forEach((button) => {
    button.addEventListener("click", async () => {
      try {
        await getCart();
      } finally {
        openDrawer();
      }
    });
  });

  root.querySelectorAll("[data-cart-close]").forEach((button) => {
    button.addEventListener("click", closeDrawer);
  });
  backdrop?.addEventListener("click", closeDrawer);

  menuOpenButton?.addEventListener("click", openMenu);
  menuCloseButton?.addEventListener("click", () => closeMenu());
  menuBackdrop?.addEventListener("click", () => closeMenu());
  mobileMenu?.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", () => closeMenu(false));
  });

  root.querySelectorAll("[data-quick-add]").forEach((button) => {
    button.addEventListener("click", async () => {
      if (button.disabled) return;
      const variantId = Number(button.dataset.variantId);
      if (!variantId) return;

      const originalText = button.textContent;
      button.disabled = true;
      button.textContent = "…";

      try {
        const response = await fetch(routeRoot + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }],
          }),
        });
        if (!response.ok) throw new Error("Unable to add item");
        await getCart();
        openDrawer();
      } catch (error) {
        button.textContent = "Try again";
        window.setTimeout(() => {
          button.textContent = originalText;
        }, 1400);
      } finally {
        button.disabled = false;
        if (button.textContent === "…") button.textContent = originalText;
      }
    });
  });

  cartItems?.addEventListener("click", async (event) => {
    const removeButton = event.target.closest("[data-cart-remove]");
    if (!removeButton) return;
    removeButton.disabled = true;
    try {
      const response = await fetch(routeRoot + "cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          id: removeButton.dataset.cartRemove,
          quantity: 0,
        }),
      });
      if (!response.ok) throw new Error("Unable to update cart");
      renderCart(await response.json());
    } finally {
      removeButton.disabled = false;
    }
  });

  root.querySelector("[data-search-open]")?.addEventListener("click", () => {
    searchOverlay?.classList.add("is-open");
    searchOverlay?.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("hiq-lock");
    window.setTimeout(() => searchInput?.focus(), 120);
  });

  const closeSearch = () => {
    searchOverlay?.classList.remove("is-open");
    searchOverlay?.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("hiq-lock");
  };

  root.querySelector("[data-search-close]")?.addEventListener("click", closeSearch);
  searchOverlay?.addEventListener("click", (event) => {
    if (event.target === searchOverlay) closeSearch();
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Tab" && mobileMenu?.classList.contains("is-open")) {
      const focusable = [...mobileMenu.querySelectorAll('a[href], button:not([disabled])')];
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last?.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first?.focus();
      }
      return;
    }
    if (event.key !== "Escape") return;
    closeDrawer();
    closeSearch();
    closeMenu(false);
  });

  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const finePointer = window.matchMedia("(pointer: fine)").matches;

  if (!reducedMotion && finePointer && heroStage) {
    heroStage.addEventListener("pointermove", (event) => {
      const bounds = heroStage.getBoundingClientRect();
      const x = (event.clientX - bounds.left) / bounds.width - 0.5;
      const y = (event.clientY - bounds.top) / bounds.height - 0.5;
      heroStage.style.setProperty("--tilt-x", (-y * 4.5).toFixed(2) + "deg");
      heroStage.style.setProperty("--tilt-y", (x * 6).toFixed(2) + "deg");
      heroStage.style.setProperty("--shift-x", (x * 12).toFixed(2) + "px");
      heroStage.style.setProperty("--shift-y", (y * 9).toFixed(2) + "px");
    });

    heroStage.addEventListener("pointerleave", () => {
      heroStage.style.setProperty("--tilt-x", "0deg");
      heroStage.style.setProperty("--tilt-y", "0deg");
      heroStage.style.setProperty("--shift-x", "0px");
      heroStage.style.setProperty("--shift-y", "0px");
    });
  }

  if (!reducedMotion && "IntersectionObserver" in window) {
    const revealTargets = root.querySelectorAll(
      ".goal-card, .performance-copy, .performance-stage, .standard-grid article, .join > div"
    );
    const revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-visible");
          revealObserver.unobserve(entry.target);
        });
      },
      { threshold: 0.16 }
    );
    revealTargets.forEach((element, index) => {
      element.classList.add("hiq-reveal");
      element.style.setProperty("--reveal-delay", Math.min(index % 3, 2) * 90 + "ms");
      revealObserver.observe(element);
    });
  }

  window.addEventListener("pageshow", (event) => {
    if (event.persisted) getCart().catch(() => {});
  });
  window.addEventListener("focus", () => getCart().catch(() => {}));
  getCart().catch(() => {});
})();

